import Link from 'next/link';
import { Lang } from '@models/lang';
import { FunctionComponent } from 'react';
import CardContent from './CardContent';

interface Props {
  lang: Lang;
}

const CardLang: FunctionComponent<Props> = ({ lang }) => {
  if (!lang.active) {
    return <CardContent lang={lang} />;
  }
  return (
    <Link href={`langs/${lang.id}`} passHref>
      <a>
        <CardContent lang={lang} />
      </a>
    </Link>
  );
};

export default CardLang;
